// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__xQECX","options":"AnswerScale_options__2a_Cd","selected":"AnswerScale_selected__3c1Sa"};